// Charter version + declaration label.
// Used by Inscription form and stored as evidence in `charter_acceptances`.
export const CHARTE_VERSION = "16-06-2026";

export const CHARTE_DECLARATION_TEXT =
  "Je certifie sur l'honneur être ou avoir été conseiller de la plateforme iAdvize/Ibbü et l'exactitude des informations fournies. J'ai lu et j'accepte la charte du Collectif, notamment la déclaration sur l'honneur (article 3 bis) et l'engagement de confidentialité (article 3 ter).";

// Privacy Policy version + declaration label.
// Used by Inscription form and stored as evidence in `privacy_acceptances`.
// ⚠️ Must stay in sync with PRIVACY_VERSION_CONST / PRIVACY_DECLARATION_CONST
// inside the Postgres function `create_inscription_with_charter`.
export const PRIVACY_VERSION = "16-06-2026";

export const PRIVACY_DECLARATION_TEXT =
  "J'accepte que les informations que je fournis soient collectées et traitées par le collectif dans le but de m'informer, de partager des témoignages et d'organiser une démarche juridique groupée. Je comprends que mes données pourront être communiquées, avec mon accord explicite ultérieur, pour faciliter une mise en relation avec un avocat spécialisé, conformément à notre Politique de Confidentialité.";
